import React from 'react';
import { FormSection } from '@/shared/components/ui';
import { NotifyContactFields, NotifyInternalFields } from './shared';
import type { UseProjectDraftReturn } from '../../hooks/useProjectDraft';

export interface ContatosNotificacoesTabProps {
  draft: UseProjectDraftReturn;
}

/**
 * Aba "Contatos & Notificações" — mensagens ao contato via canal (eventos +
 * template com variáveis) e notificações internas da equipe.
 *
 * Os campos vivem em componentes presentacionais compartilhados
 * (`components/form/shared/`) reutilizados pela aba de configurações do
 * workspace (Task 13). Este wrapper apenas mapeia o `draft` transiente.
 */
export const ContatosNotificacoesTab: React.FC<ContatosNotificacoesTabProps> = ({ draft }) => {
  const { value } = draft;

  return (
    <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 md:px-8 py-8 space-y-6">
      <FormSection
        icon="message-circle"
        title="Mensagens ao contato"
        description="Avise o cliente automaticamente conforme o projeto avança"
      >
        <NotifyContactFields
          testIdPrefix="project-form"
          contactIds={value.contactIds}
          onContactIdsChange={draft.setContactIds}
          channelId={value.channelId}
          onChannelIdChange={(id) => draft.setField('channelId', id)}
          events={value.events}
          onToggleEvent={draft.toggleEvent}
          messageTemplate={value.messageTemplate}
          onMessageTemplateChange={(v) => draft.setField('messageTemplate', v)}
        />
      </FormSection>

      <FormSection icon="bell" title="Notificações internas" description="Alertas para a equipe do projeto">
        <NotifyInternalFields
          testIdPrefix="project-form-internal"
          value={value.internal}
          onChange={draft.setInternal}
        />
      </FormSection>
    </div>
  );
};

ContatosNotificacoesTab.displayName = 'ContatosNotificacoesTab';
